import React, { createContext, useContext, useState, useCallback } from "react";

const FilterContext = createContext();

const initialFilters = {
  center: "",
  collectionSite: null,
  bloodGroup: null,
  ageRange: { min: "", max: "" },
  state: null,
  dateRange: { start: null, end: null },
  barCode: "",
  bagType: null,
  donationType: null,
  subDonationType: null,
  gender: null,
};

export const FilterProvider = ({ children }) => {
  const [filters, setFilters] = useState(initialFilters);
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [expandedSections, setExpandedSections] = useState({
    basic: true,
    donation: true,
    advanced: false,
  });

  const updateFilter = useCallback((key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
    setIsFiltersApplied(false);
  }, []);

  const clearFilters = useCallback(() => {
    setFilters(initialFilters);
    setIsFiltersApplied(false);
  }, []);

  const applyFilters = useCallback(() => {
    setIsFiltersApplied(true);
    return filters;
  }, [filters]);

  const toggleSection = useCallback((section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  }, []);

  const hasActiveFilters = useCallback(() => {
    return (
      filters.center !== "" ||
      filters.collectionSite !== null ||
      filters.bloodGroup !== null ||
      filters.ageRange.min !== "" ||
      filters.ageRange.max !== "" ||
      filters.state !== null ||
      filters.dateRange.start !== null ||
      filters.dateRange.end !== null ||
      filters.barCode !== "" ||
      filters.bagType !== null ||
      filters.donationType !== null ||
      filters.subDonationType !== null ||
      filters.gender !== null
    );
  }, [filters]);

  const getActiveFilterCount = useCallback(() => {
    let count = 0;
    if (filters.center) count++;
    if (filters.collectionSite) count++;
    if (filters.bloodGroup) count++;
    if (filters.ageRange.min || filters.ageRange.max) count++;
    if (filters.state) count++;
    if (filters.dateRange.start || filters.dateRange.end) count++;
    if (filters.barCode) count++;
    if (filters.bagType) count++;
    if (filters.donationType) count++;
    if (filters.subDonationType) count++;
    if (filters.gender) count++;
    return count;
  }, [filters]);

  return (
    <FilterContext.Provider
      value={{
        filters,
        updateFilter,
        clearFilters,
        applyFilters,
        isFiltersApplied,
        expandedSections,
        toggleSection,
        hasActiveFilters,
        getActiveFilterCount,
      }}
    >
      {children}
    </FilterContext.Provider>
  );
};

export const useFilter = () => {
  const context = useContext(FilterContext);
  if (!context) {
    throw new Error("useFilter must be used within a FilterProvider");
  }
  return context;
};

export default FilterProvider;
